export enum SizeButton {
  SMALL = 'SMALL',
  STANDARD = 'STANDARD',
  LARGE = 'LARGE',
  EXTRA_SMALL = 'EXTRA_SMALL',
}
